import React from 'react'
import {
  Archive,
  ArrowUUpLeft,
  Briefcase,
  CalendarBlank,
  ChartBar,
  ChartLine,
  CheckSquare,
  ClipboardText,
  Coin,
  CurrencyCircleDollar,
  DownloadSimple,
  FileText,
  Gift,
  Graph,
  House,
  IdentificationBadge,
  Lightning,
  Package,
  ShareNetwork,
  ShieldCheck,
  ShoppingCart,
  Signpost,
  SquaresFour,
  Storefront,
  Tag,
  Truck,
  Users,
  UsersThree,
  Wallet
} from '@phosphor-icons/react'

export const NAV_ICONS = {
  home: House,
  event_note: CalendarBlank,
  store: Storefront,
  work: Package,
  hub: ShareNetwork,
  shopping_basket: Gift,
  payments: Wallet,
  redeem: Briefcase,
  checklist: CheckSquare,
  group: Users,
  admin_panel_settings: ShieldCheck,
  route: Signpost,
  account_tree: Graph,
  assignment_ind: IdentificationBadge,
  person: Lightning,
  assignment: ClipboardText,
  tag: Tag,
  shopping_cart: ShoppingCart,
  undo: ArrowUUpLeft,
  local_shipping: Truck,
  electric_moped: UsersThree,
  paid: Coin,
  analytics: ChartBar,
  inventory_2: Archive,
  currency_exchange: CurrencyCircleDollar,
  monitoring: SquaresFour,
  finance_mode: ChartLine,
  bar_chart: FileText,
  download_2: DownloadSimple
}

export const NavIcon = ({ name, size = 16, className = 'route-plan-icon', weight = 'regular' }) => {
  const Icon = NAV_ICONS[name]
  if (!Icon) return null

  return <Icon className={className} size={size} weight={weight} />
}
